"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
/**
 * Since RadioButtons are usually part of a group, the `isChecked` determinew wheter this radio
 * button should be checked based on the group's value. If a `groupValue` is not provided, then it
 * attempts to use the `checked` attribute instead (for standalone RadioButtons)
 *
 */
function isChecked(groupValue, value, checked) {
    return groupValue ? groupValue === value : checked;
}
var RadioButton = function (_a) {
    var label = _a.label, reverse = _a.reverse, name = _a.name, checked = _a.checked, value = _a.value, groupValue = _a.groupValue, onChange = _a.onChange;
    var margin = reverse ? "ml-2" : "mr-2";
    checked = isChecked(groupValue, value, checked);
    var checkbox = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { name: name, onChange: onChange, className: "RadioButtonHidden", value: value, type: "radio", checked: checked }),
        react_1.default.createElement("div", { className: "RadioButtonGlyph border border-grey align-middle\ntext-grey-darker items-center justify-center ".concat(margin) },
            react_1.default.createElement("div", { className: "RadioButtonMark invisible bg-teal-dark" }))));
    return (react_1.default.createElement("span", { className: "RadioButton" }, label ? (react_1.default.createElement(_1.Label, { inline: true, reverse: !reverse, text: label }, checkbox)) : (react_1.default.createElement("label", { className: "relative" }, checkbox))));
};
exports.RadioButton = RadioButton;
